export const SOCIAL_NETWORK_OPTIONS = [
    {
        key: "instagram",
        label: "Instagram",
        icon: "/img/networks-icons/instagram.png",
        baseUrl: "https://instagram.com/",
        placeholder: "tu-usuario"
    },
    {
        key: "facebook",
        label: "Facebook",
        icon: "/img/networks-icons/facebook.png",
        baseUrl: "https://facebook.com/",
        placeholder: "tu-pagina"
    },
    {
        key: "tiktok",
        label: "TikTok",
        icon: "/img/networks-icons/tik-tok.png",
        baseUrl: "https://tiktok.com/@",
        placeholder: "tu-usuario"
    },
    {
        key: "twitter",
        label: "Twitter / X",
        icon: "/img/networks-icons/x.png",
        baseUrl: "https://x.com/",
        placeholder: "tu-usuario"
    },
    {
        key: "youtube",
        label: "YouTube",
        icon: "/img/networks-icons/youtube.png",
        baseUrl: "https://youtube.com/@",
        placeholder: "tu-canal"
    },
    {
        key: "linkedin",
        label: "LinkedIn",
        icon: "/img/networks-icons/linkedin.png",
        baseUrl: "https://linkedin.com/company/",
        placeholder: "tu-empresa"
    },
    {
        key: "threads",
        label: "Threads",
        icon: "/img/networks-icons/threads.png",
        baseUrl: "https://threads.net/@",
        placeholder: "tu-usuario"
    },
    {
        key: "pinterest",
        label: "Pinterest",
        icon: "/img/networks-icons/pinterest.png",
        baseUrl: "https://pinterest.com/",
        placeholder: "tu-usuario"
    },
    {
        key: "twitch",
        label: "Twitch",
        icon: "/img/networks-icons/twitch.png",
        baseUrl: "https://twitch.tv/",
        placeholder: "tu-canal"
    }
];
